export const REMOVE_MESSAGES = 0
export const ADDED_FROM_ANOTHER_PARTNER = 1
export const NO_MORE_PRODUCTS = 2
